<template>
  <v-container fluid>
    <!-- Formular zur Erfassung einer neuen Messung -->
    <v-form ref="measurementForm">
      <v-row no-gutters>
        <!-- Messfelder -->
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.chest" label="Brust (cm)" type="number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.stomach" label="Bauch (cm)" type="number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.hips" label="Hüfte (cm)" type="number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.upperArmR" label="Oberarm R (cm)" type="number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.upperArmL" label="Oberarm L (cm)" type="number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.thighR" label="Oberschenkel R (cm)" type="number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="measurement.thighL" label="Oberschenkel L (cm)" type="number"></v-text-field>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <!-- Bild-Uploads für die vier Ansichten -->
      <v-row no-gutters>
        <v-col cols="12" sm="6" md="3">
          <v-file-input v-model="measurement.images.front" label="Vorderansicht" accept="image/*" prepend-icon="mdi-camera"></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-file-input v-model="measurement.images.left" label="Seitenansicht (links)" accept="image/*" prepend-icon="mdi-camera"></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-file-input v-model="measurement.images.right" label="Seitenansicht (rechts)" accept="image/*" prepend-icon="mdi-camera"></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-file-input v-model="measurement.images.back" label="Rückansicht" accept="image/*" prepend-icon="mdi-camera"></v-file-input>
        </v-col>
      </v-row>

      <!-- Schaltfläche zum Speichern der Messung -->
      <v-btn color="primary" class="mt-4" @click="saveMeasurement"> Messung speichern </v-btn>
    </v-form>

    <v-divider class="my-4"></v-divider>

    <!-- Anzeige der Messhistorie -->
    <v-card outlined>
      <v-card-title>Messhistorie</v-card-title>
      <v-card-text>
        <v-data-table :headers="historyHeaders" :items="measurementHistory" class="elevation-1">
          <template v-slot:item.date="{ item }">
            {{ formatDate(item.date) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import api from "../../../api"
import moment from "moment"

export default {
  props: {
    user: {
      required: true,
    },
  },
  data() {
    return {
      // Model für eine neue Messung
      measurement: {
        date: new Date(),
        chest: null,
        stomach: null,
        hips: null,
        upperArmR: null,
        upperArmL: null,
        thighR: null,
        thighL: null,
        images: {
          front: null,
          left: null,
          right: null,
          back: null,
        },
      },
      // Historie aller Messungen
      measurementHistory: [],
      // Header für die History-Tabelle
      historyHeaders: [
        { text: "Datum", value: "date" },
        { text: "Brust (cm)", value: "chest" },
        { text: "Bauch (cm)", value: "stomach" },
        { text: "Hüfte (cm)", value: "hips" },
        { text: "Oberarm R (cm)", value: "upperArmR" },
        { text: "Oberarm L (cm)", value: "upperArmL" },
        { text: "Oberschenkel R (cm)", value: "thighR" },
        { text: "Oberschenkel L (cm)", value: "thighL" },
      ],
    }
  },
  async created() {
    await this.loadHistory()
    this.$emit("loaded")
  },
  methods: {
    // Lädt alle Messungen für den aktuellen Nutzer über das Measurement-API
    async loadHistory() {
      try {
        const data = await api.fetchMeasurements()
        this.measurementHistory = data
      } catch (error) {
        console.error("Fehler beim Laden der Messhistorie:", error)
      }
    },
    // Speichert eine neue Messung
    async saveMeasurement() {
      try {
        // Hinweis: Bei den Bild-Uploads ist ggf. ein spezielles File-Handling (z.B. mit FormData) notwendig.
        // Hier werden die übergebenen Felder als JSON gespeichert (z.B. wenn bereits Dateipfade vorliegen).
        const saved = await api.addMeasurement(this.measurement)
        // Neue Messung an den Anfang der Historie setzen
        this.measurementHistory.unshift(saved)
        this.resetForm()
        this.$toast && this.$toast.success("Messung erfolgreich gespeichert!")
      } catch (error) {
        console.error("Fehler beim Speichern der Messung:", error)
        this.$toast && this.$toast.error("Fehler beim Speichern der Messung.")
      }
    },
    // Setzt das Messformular zurück
    resetForm() {
      this.measurement = {
        date: new Date(),
        chest: null,
        stomach: null,
        hips: null,
        upperArmR: null,
        upperArmL: null,
        thighR: null,
        thighL: null,
        images: {
          front: null,
          left: null,
          right: null,
          back: null,
        },
      }
      // Falls du ein v-form-Reset benötigst, kannst du das Formular auch über das Ref zurücksetzen:
      if (this.$refs.measurementForm) this.$refs.measurementForm.reset()
    },
    // Formatiert das Datum in ein lesbares Format
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY")
    },
  },
}
</script>

<style scoped>
/* Optional: eigene Styles zur Anpassung des Layouts */
</style>
